import {SlArrowDown, SlArrowRight} from "react-icons/sl";
import React, {useState} from "react";

const FilterSubItem = ({ subItems, category, expandedSubCategories, toggleSubCategoryExpansion, toggleCategorySelection, selectedOptions, item, subItem, parentPath, isFromListing }) => {
    const [radioButtonChecked,setRadioButtonChecked] = useState(false)
    const handleCheckedRadioButton = (booleanValue, subSubItem) => {
        setRadioButtonChecked(booleanValue)
        toggleCategorySelection(subSubItem?.title, item, null, isFromListing)
    };

    return (
        <ul className="filter-items-sublist" style={{ listStyleType: 'none', padding: '10px' }}>
            {subItems.map((subSubItem, subSubIndex) => {

                const currentPath = parentPath ? `${parentPath} > ${subSubItem?.title}` : `${subItem?.title} > ${subSubItem?.title}`;
                return (
                    <li key={subSubIndex} className="filter-item">
                        <label className="filter-item-label">

                            {isFromListing===true &&(
                                expandedSubCategories[subSubItem?.title] ? (
                                    <input
                                        type="radio"
                                        className="custom-radio"
                                        name={`filter-radio-${subItem?.title}`}
                                        value={item?.title}
                                        checked={radioButtonChecked}
                                        onChange={() => handleCheckedRadioButton(!radioButtonChecked, subSubItem)}
                                    />
                                ) : (
                                    <input
                                        type="radio"
                                        className="custom-radio"
                                        name={`filter-radio-${subItem?.title}`}
                                        value={item?.title}
                                        checked={radioButtonChecked}
                                        onChange={() =>handleCheckedRadioButton(!radioButtonChecked, subSubItem)}
                                    />
                                )
                            )}
                            {subSubItem?.items && subSubItem?.items.length > 0 && isFromListing===false &&(
                                expandedSubCategories[subSubItem?.title] ? (
                                    <SlArrowDown
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => toggleSubCategoryExpansion(category, subSubItem?.title)}
                                    />
                                ) : (
                                    <SlArrowRight
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => toggleSubCategoryExpansion(category, subSubItem?.title)}
                                    />
                                )
                            )}
                                <label style={{ cursor: 'pointer' }} onClick={() =>
                                    isFromListing===false ? toggleCategorySelection(subSubItem?.title, item, currentPath, isFromListing) : handleCheckedRadioButton(!radioButtonChecked, subSubItem)}>
                                    &nbsp; {subSubItem?.title}
                                </label>

                            {isFromListing===false &&
                                <input
                                    type="checkbox"
                                    className="custom-checkbox"
                                    style={{
                                        marginLeft: '10px',
                                        display: selectedOptions[item?.categoryId]?.some((entry) => entry?.category === subSubItem?.title) ? 'inline-block' : 'none',
                                    }}
                                    checked
                                    onChange={() => toggleCategorySelection(subSubItem?.title, item, currentPath)}
                                />
                            }

                            <span className={"count"}>({subSubItem.aggregate})</span>
                        </label>
                        {subSubItem?.items && subSubItem?.items.length > 0 && expandedSubCategories && expandedSubCategories[subSubItem?.title]
                            && isFromListing===false &&  (
                            <FilterSubItem
                                subItems={subSubItem?.items}
                                category={category}
                                expandedSubCategories={expandedSubCategories}
                                toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                                toggleCategorySelection={toggleCategorySelection}
                                selectedOptions={selectedOptions}
                                item={item}
                                subItem={subSubItem}
                                parentPath={currentPath}
                            />
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default FilterSubItem;

